import dayjs from 'dayjs'

import { InfoTooltip } from 'common/InfoTooltip/InfoTooltip'
import { ReactComponent as DocumentIcon } from 'assets/icons/document_16.svg'
import { ReactComponent as HandbookIcon } from 'assets/icons/handbook_16--solid.svg'
import { ArticleTypes, AlmanacFile as File } from 'types'

import Styles from './ArticleRow.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface ArticleRowProps {
  article: File
  nestedLevel: number
}

export const ArticleRow = ({ article, nestedLevel }: ArticleRowProps) => {
  const { accessor_names, updated_at } = article
  const accessorNameCount = accessor_names.length
  const isHandbook = article.type === ArticleTypes.HANDBOOK
  const modifiedTime = `${dayjs(updated_at).format('MMM D')} at ${dayjs(updated_at).format('h:mm a')}`
  const nestedInset = nestedLevel * 24
  const { isMobile } = useResponsiveDesign()

  const FileIcon = () => {
    let icon = <DocumentIcon className={Styles.articleIcon} />
    if (article.header_emoji) icon = <span>{article.header_emoji}</span>
    if (isHandbook) icon = <HandbookIcon className={Styles.handbookIcon} />

    return <span className={Styles.titleDocIconNoBranches}>{icon}</span>
  }

  const AccessorInfo = () => {
    return accessor_names?.length ? (
      <InfoTooltip
        description={
          <>
            {accessor_names.slice(0, 5).map((name, index) => (
              <div key={`accessor-name-${index}`}>{name}</div>
            ))}
            {accessorNameCount > 5 && <div>+ {accessorNameCount - 5} More</div>}
          </>
        }
        placement="left"
        className={Styles.narrowTooltip}
      >
        <div className={Styles.column}>{article.accessor_info}</div>
      </InfoTooltip>
    ) : (
      <div className={Styles.column}>{article.accessor_info}</div>
    )
  }

  return (
    <div className={Styles.articleRow}>
      <span style={{ paddingLeft: nestedInset }} className={Styles.titleColumn}>
        <span className={Styles.folderIcon}>
          <FileIcon />
        </span>
        <span className={Styles.title}>{article.title}</span>
      </span>
      {!isMobile && <span className={Styles.column}>{modifiedTime}</span>}
      <AccessorInfo />
    </div>
  )
}
